module.exports = __webpack_public_path__ + "img/vote_illustration7.29d5c414.png";